import { ApiResponse, PayInvoicesRequest } from 'vopay';
import { useState, useEffect } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';
const { api } = vopayApi;

export default function usePostInvoices() {
  const source = axios.CancelToken.source();

  const [response, setResponse] = useState<ApiResponse>();
  const [loading, setLoading] = useState<boolean>(false);
  const postInvoices = async (requestParams: PayInvoicesRequest) => {
    try {
      setLoading(true);
      const res = await api.postInvoices(requestParams, source);
      setResponse(res);
      if (!res.Success) throw new Error(res.ErrorMessage);
      return res;
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setLoading(false);
    }
  };

  const resetInvoicesResponse = () => {
    setResponse(undefined);
  };

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  return {
    loading,
    response,
    postInvoices,
    resetInvoicesResponse,
  };
}
